module.exports = __webpack_public_path__ + "static/media/logo-abella-las-dehesas-blanc.2394bd62.png";